import { TextEmbedItem, TextEmbedWrapper } from '@anm/components/TextEmbed';
import isMobileOrIPad from '@anm/helpers/is/isMobileOrIPad';
import styled from 'styled-components';

export const TextWrapper = styled.div`
  ${TextEmbedWrapper} {
    text-align: left;
    text-indent: ${isMobileOrIPad() ? '110px' : '180px'};
    transform: translateY(-24px);
    line-height: 28px;
    margin-bottom: -10px;
  }

  ${TextEmbedItem} {
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`;
